<template>
  <span style="font-size:2em">{{ testo }}</span>
</template>

<script>


export default {
  name: "CountDown",
  data() {
    return {
      testo: null
    };
  },
  mounted(){
     var thisp = this;
     var x = setInterval(function() {
      var cd =  new Date(thisp.countDownDate).getTime();
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance =  cd - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the result in the element with id="demo"
      thisp.testo = days + " giorni " + hours + " ore "
      + minutes + "m " + seconds + "s ";

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        this.testo = "SCADUTA";
      }
    }, 1000);
  },
  components: {
  },
  props: ["countDownDate"],
};
</script>


<style scoped></style>
